
import {defineComponent, reactive} from 'vue';
import MegamiSlotCylinder from '@/components/MegamiSlotCylinder.vue';
import MegamiSlotButton from '@/components/MegamiSlotButton.vue';
import {pick} from '@/modules/pick';
import json from '@/assets/megami_list.json';

export default defineComponent({
  'name': 'MegamiSlot',
  'components': {
    MegamiSlotCylinder,
    MegamiSlotButton,
  },
  setup(props, context) {
    json.megamiList.forEach(megami => {
      const link = document.createElement('link');
      link.setAttribute('rel', 'preload');
      link.setAttribute('as', 'image');
      link.setAttribute('type', 'image/png');
      link.setAttribute('href', '/megami/' + megami.code + '.png');
      document.head.appendChild(link);
    });

    const state = reactive({
      'state': 'loading',
      'megamiTuple': [
        {'code': 'na-10-kururu-a1', 'name': '「探索者」クルル',},
        {'code': 'na-10-kururu-a1', 'name': '「探索者」クルル',},
        {'code': 'na-10-kururu-a1', 'name': '「探索者」クルル',},
      ],
    });

    setTimeout(() => {state.state = 'not-ready';}, 200);

    let timerId: number|undefined = undefined;

    const rollStart = () => {
      state.state = 'running';

      const f = () => {state.megamiTuple = pick(3);};
      timerId = window.setInterval(f, 50);
    };
    const rollStop = () => {
      state.state = 'stopping';

      if (timerId) {
        window.clearInterval(timerId);
        timerId = undefined;
      }
      setTimeout(() => {
        state.state = 'ready';
      }, 300);
    };
    const share = (service: string) => {
      const names = state.megamiTuple.map(megami => '・' + megami.name).join('\n');
      let url = '';
      switch (service) {
        case 'twitter': {
          const text = encodeURI(`今回のランダム3柱は:\n${names}\n`);
          url = `https://twitter.com/intent/tweet?hashtags=ふるよに&text=${text}&url=${location.href}`;
          break;
        }
      }
      window.open(url, 'share');
    };

    return {
      state,
      rollStart,
      rollStop,
      share,
    };
  },
});
